module.exports = __webpack_public_path__ + "cloud.e5c98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/cloud.svg
// module id = ./src/_asset/sources/assets/images/@svg/cloud.svg
// module chunks = main